// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"9b76c1d1","453":"76804115","705":"bd817b27"}[chunkId] + ".chunk.js";
};